module.exports = __webpack_public_path__ + "static/media/pdf_icon.a3221986.svg";